<template>
<a-modal
    :title="viewTitle"
    visible
    @ok="save"
    @cancel="cancel"
  >
  <div v-if="!record">
    <ak-inputs v-model="addData.data1" :options="addOptions.options1" ref="input1" />
    <ak-inputs v-model="addData.data2" :options="addOptions.options2" ref="input2" />
    <ak-inputs v-if="addData.data2.redRole==='woker' || addData.data2.redRole==='stylist'" v-model="addData.data3" :options="addOptions.options3" ref="input3" />
    <ak-inputs v-else v-model="addData.data4" :options="addOptions.options4" ref="input3" />
    <ak-inputs v-model="addData.data5" :options="addOptions.options5" ref="input4" />
  </div>
  <div v-else>
    <ak-inputs v-model="editData" :options="editOptions" ref="input" />
  </div>
</a-modal>
</template>
<script>
import { tkParse, tkRegions } from '@moke/vue-tk'
const reg = /^1[3456789]\d{9}$/
export default {
  props: {
    record: Object, // 当前行的数据
    vm: Object
  },
  data () {
    return {
      editData: {},
      addData: {
        data1: { redType: 'red', redImg: [] },
        data2: { redRole: 'woker' },
        data3: {},
        data4: {},
        data5: { redStatus: 'wait' }
      },
      viewTitle: '添加红黑榜',
      addOptions: {
        options1: [
          {
            name: 'redTitle', // 表单字段名，必填，用来分辨不同的input
            note: '红黑榜标题', // 表单显示的名称，如果为空则显示表单name
            type: 'String', // 表单输入类型，所有数据模型类型都可以使用，默认为String
            validators: [ // 表单验证，与model中的validators用法一致
              (val) => val ? null : '不可为空'
            ]
          },
          {
            name: 'redImg', // 表单字段名，必填，用来分辨不同的input
            note: '用户上传参考图片', // 表单显示的名称，如果为空则显示表单name
            type: 'Array', // 表单输入类型，所有数据模型类型都可以使用，默认为String
            items: {
              type: 'Image'
            }
          },
          {
            name: 'video',
            note: '用户上传参考视频',
            type: 'Video'
          },
          {
            name: 'user', // 表单字段名，必填，用来分辨不同的input
            note: '发布用户', // 表单显示的名称，如果为空则显示表单name
            type: 'Pointer', // 表单输入类型，所有数据模型类型都可以使用，默认为String
            targetClass: '_User', // 当数据类型为Pointer时必填，指定查询对象
            searchKey: ['wechatName'], // 仅在 Pointer类型下有效，根据输入内容搜索的字段名
            listWhere: (where) => {
              where.authority = { $ne: 'administrator' }
            }, // 设置可选项的查询条件
            validators: [ // 表单验证，与model中的validators用法一致
              (val) => val ? null : '不可为空'
            ]
          },
          {
            name: 'redType', // 表单字段名，必填，用来分辨不同的input
            note: '类型', // 表单显示的名称，如果为空则显示表单name
            type: 'Select', // 表单输入类型，所有数据模型类型都可以使用，默认为String
            validators: [ // 表单验证，与model中的validators用法一致
              (val) => val ? null : '不可为空'
            ],
            items: {
              red: '红榜',
              black: '黑榜'
            }
          },
          {
            name: 'detailAddress',
            note: '详细地址',
            validators: [
              (value) => value ? null : '详细地址不可为空'
            ]
          }
        ],
        options2: [
          {
            name: 'redRole', // 表单字段名，必填，用来分辨不同的input
            note: '红黑榜身份', // 表单显示的名称，如果为空则显示表单name
            type: 'Select', // 表单输入类型，所有数据模型类型都可以使用，默认为String
            validators: [ // 表单验证，与model中的validators用法一致
              (val) => val ? null : '不可为空'
            ],
            items: {
              woker: '个人',
              // company: '装修公司',
              // stylist: '设计师',
              merchant: '公司'
            }
          },
          {
            name: 'redName', // 表单字段名，必填，用来分辨不同的input
            note: '姓名或名称', // 表单显示的名称，如果为空则显示表单name
            tooltip: '如果红黑榜身份为个人则填写姓名',
            type: 'String', // 表单输入类型，所有数据模型类型都可以使用，默认为String
            validators: [ // 表单验证，与model中的validators用法一致
              (val) => val ? null : '不可为空'
            ]
          }
        ],
        options3: [
          {
            name: 'phone', // 表单字段名，必填，用来分辨不同的input
            note: '手机号', // 表单显示的名称，如果为空则显示表单name
            type: 'String', // 表单输入类型，所有数据模型类型都可以使用，默认为String
            validators: [ // 表单验证，与model中的validators用法一致
              (val) => val ? null : '不可为空',
              (val) => !reg.test(val) ? '请输入正确格式手机号' : null
            ]
          }
        ],
        options4: [
          {
            name: 'phone', // 表单字段名，必填，用来分辨不同的input
            note: '地址', // 表单显示的名称，如果为空则显示表单name
            type: 'Region', // 表单输入类型，所有数据模型类型都可以使用，默认为String
            validators: [ // 表单验证，与model中的validators用法一致
              (val) => val ? null : '不可为空'
            ]
          }
        ],
        options5: [
          {
            name: 'redStatus', // 表单字段名，必填，用来分辨不同的input
            note: '审核状态', // 表单显示的名称，如果为空则显示表单name
            type: 'Select', // 表单输入类型，所有数据模型类型都可以使用，默认为String
            validators: [ // 表单验证，与model中的validators用法一致
              (val) => val ? null : '不可为空'
            ],
            items: {
              wait: '待审核',
              pass: '已通过',
              notPass: '未通过'
            }
          }
        ]
      },
      editOptions: [
        {
          name: 'redTitle', // 表单字段名，必填，用来分辨不同的input
          note: '红黑榜标题', // 表单显示的名称，如果为空则显示表单name
          type: 'String', // 表单输入类型，所有数据模型类型都可以使用，默认为String
          validators: [ // 表单验证，与model中的validators用法一致
            (val) => val ? null : '不可为空'
          ]
        },
        {
          name: 'redImg', // 表单字段名，必填，用来分辨不同的input
          note: '用户上传参考图片', // 表单显示的名称，如果为空则显示表单name
          type: 'Array', // 表单输入类型，所有数据模型类型都可以使用，默认为String
          validators: [ // 表单验证，与model中的validators用法一致
            (val) => val ? null : '不可为空'
          ],
          items: {
            type: 'Image'
          }
          // 客户要求取消
          // disabled: true
        },
        {
          name: 'video',
          note: '用户上传参考视频',
          type: 'Video',
          disabled: true
        },
        {
          name: 'user', // 表单字段名，必填，用来分辨不同的input
          note: '发布用户', // 表单显示的名称，如果为空则显示表单name
          type: 'Pointer', // 表单输入类型，所有数据模型类型都可以使用，默认为String
          targetClass: '_User', // 当数据类型为Pointer时必填，指定查询对象
          searchKey: ['wechatName'], // 仅在 Pointer类型下有效，根据输入内容搜索的字段名
          listWhere: (where) => {
            where.authority = { $ne: 'administrator' }
          }, // 设置可选项的查询条件
          validators: [ // 表单验证，与model中的validators用法一致
            (val) => val ? null : '不可为空'
          ],
          disabled: true
        },
        {
          name: 'redType', // 表单字段名，必填，用来分辨不同的input
          note: '类型', // 表单显示的名称，如果为空则显示表单name
          type: 'Select', // 表单输入类型，所有数据模型类型都可以使用，默认为String
          validators: [ // 表单验证，与model中的validators用法一致
            (val) => val ? null : '不可为空'
          ],
          items: {
            red: '红榜',
            black: '黑榜'
          }
        },
        {
          name: 'redRole', // 表单字段名，必填，用来分辨不同的input
          note: '红黑榜身份', // 表单显示的名称，如果为空则显示表单name
          type: 'Select', // 表单输入类型，所有数据模型类型都可以使用，默认为String
          validators: [ // 表单验证，与model中的validators用法一致
            (val) => val ? null : '不可为空'
          ],
          items: {
            woker: '个人',
            // company: '装修公司',
            // stylist: '设计师',
            merchant: '公司'
          }
          // 客户要求取消
          // disabled: true
        },
        {
          name: 'redName', // 表单字段名，必填，用来分辨不同的input
          note: '姓名或名称', // 表单显示的名称，如果为空则显示表单name
          type: 'String', // 表单输入类型，所有数据模型类型都可以使用，默认为String
          validators: [ // 表单验证，与model中的validators用法一致
            (val) => val ? null : '不可为空'
          ],
          disabled: true
        },
        {
          name: 'phone', // 表单字段名，必填，用来分辨不同的input
          note: '地址/手机号', // 表单显示的名称，如果为空则显示表单name
          type: 'String', // 表单输入类型，所有数据模型类型都可以使用，默认为String
          validators: [ // 表单验证，与model中的validators用法一致
            (val) => val ? null : '不可为空'
          ],
          disabled: true
        },
        {
          name: 'detailAddress',
          note: '详细地址',
          type: 'String',
          validators: [
            (value) => value ? null : '详细地址不可为空'
          ],
          disabled: true
        },
        {
          name: 'redStatus', // 表单字段名，必填，用来分辨不同的input
          note: '审核状态', // 表单显示的名称，如果为空则显示表单name
          type: 'Select', // 表单输入类型，所有数据模型类型都可以使用，默认为String
          validators: [ // 表单验证，与model中的validators用法一致
            (val) => val ? null : '不可为空'
          ],
          items: {
            wait: '待审核',
            pass: '已通过',
            notPass: '未通过'
          }
        }
      ]
    }
  },
  mounted () {
    if (this.record) {
      this.editData = {
        redTitle: this.record.redTitle,
        redImg: this.record.redImg,
        video: this.record.video,
        user: this.record.user,
        redType: this.record.redType,
        redRole: this.record.redRole,
        redName: this.record.redName,
        phone: this.record.phone,
        redStatus: this.record.redStatus,
        detailAddress: this.record.detailAddress
      }
      this.viewTitle = '红黑榜审核'
    }
  },
  methods: {
    async save () {
      if (!this.record) {
        let erros1 = await this.$refs.input1.validate()
        let erros2 = await this.$refs.input2.validate()
        let erros3 = await this.$refs.input3.validate()
        let erros4 = await this.$refs.input4.validate()
        console.log(this.addData.data1.redImg, 'image0')
        if (Object.keys(erros1).length) return // 如果有错误，中断执行，不需要提示（inputs本 身具有提示）
        if (Object.keys(erros2).length) return // 如果有错误，中断执行，不需要提示（inputs本身具有提示）
        if (Object.keys(erros3).length) return // 如果有错误，中断执行，不需要提示（inputs本身具有提示）
        if (Object.keys(erros4).length) return // 如果有错误，中断执行，不需要提示（inputs本身具有提示）
        try {
          let phone
          if (this.addData.data2.redRole !== 'woker' && this.addData.data2.redRole !== 'stylist') {
            const arr = tkRegions.getFullName(this.addData.data4.phone).split(' ')
            phone = arr[0] + '·' + arr[1] + '·' + arr[2]
          }
          // 获取用户的openId
          const res = await tkParse.get('/classes/_User', {
            params: {
              include: ['user'],
              where: {
                objectId: this.addData.data1.user
              }
            }
          })
          await tkParse.post(`/classes/redBlack`, {
            redTitle: this.addData.data1.redTitle,
            redImg: this.addData.data1.redImg,
            video: this.addData.data1.video || '',
            user: this.addData.data1.user,
            redType: this.addData.data1.redType,
            redRole: this.addData.data2.redRole,
            redName: this.addData.data2.redName,
            region: tkRegions.getFullName(this.addData.data4.phone).split(' '),
            isDelete: false,
            openId: res.data.results[0].openId,
            phone: this.addData.data2.redRole === 'woker' || this.addData.data2.redRole === 'stylist' ? this.addData.data3.phone : phone,
            redStatus: this.addData.data5.redStatus,
            detailAddress: this.addData.data1.detailAddress
          })
          this.$notification['success']({
            message: '操作成功',
            description: '成功创建红黑榜'
          })
          this.vm.refresh()
          this.$emit('complete', 'cancel')
        } catch (e) {
          this.$notification['error']({
            message: '失败',
            description: '创建问题失败, 请重试!'
          })
        }
      } else {
        try {
          await tkParse.put(`/classes/redBlack/${this.record.objectId}`, {
            redStatus: this.editData.redStatus
          })
          this.vm.refresh()
          this.$notification['success']({
            message: '操作成功',
            description: '已成功修改审核状态'
          })
          this.$emit('complete', 'cancel')
        } catch (e) {
          this.$notification['error']({
            message: '失败',
            description: '修改审核状态失败, 请重试!'
          })
        }
      }
    },
    cancel () {
      this.$emit('complete', 'cancel')
    }
  }
}
</script>
